// #region Imports
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import PDFViewer from "./PDFViewer"
import DocumentosListado from "./DocumentosListado.js"
import {
  Button,
  Col,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import DropzoneComponent from "./DropzoneComponent"
import Spinners from "components/Common/Spinner"
import { Link } from "react-router-dom"
// #endregion

// #region selectors
import {
  useAuthIdPersonaAuthenticated,
  useDocumentosLoadingDocs,
  useDocumentosCatalogoDocs,
  useDocumentosCatalogo_xniveleducativo,
  useDocumentosDocs_xpersona,
  useDocumentosError,
  useDocumentosDocumento,
  useDocumentosId_Relacion_Persona_Documento,
  useDocumentosRefreshListaDocs,
  useDocumentosNotification,
  useDocumentosUploadDoc,
} from "store/selectors"
// #endregion

// #region actions
import {
  getControlEscolarGetPersona as onGetControlEscolarGetPersona,
  putControlEscolarPutPersona as onPutControlEscolarPutPersona,
  postDocumentosUploadFile,
  getDocumentosDocumentacion,
  getDocumentosDocumento,
  getDocumentosUnsetDocumento,
  setDocumentosid_Relacion_Persona_Documento,
  delDocumentosDelDocumento,
  unsetDocumentosRefreshListaDocs,
  unsetDocumentosNotificacion,
  putDocumentosUpdateListaDocumentos,
} from "../../store/actions"
// #endregion

// #region variables globales
// Variable para esperar a que termine de picar el botón de + o de -
let debounceTimer
// #endregion

const Documentacion = ({ oAlumno, oPersona, formik, altaAlumno = false }) => {
  //
  // #region Init
  // #endregion

  // #region const-selectors

  const refreshListaDocs = useDocumentosRefreshListaDocs()
  const error = useDocumentosError()
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const isLoading = useDocumentosLoadingDocs()
  const documentos = useDocumentosDocs_xpersona()
  const docsxEntregar = useDocumentosCatalogo_xniveleducativo()
  const docsCatalogo = useDocumentosCatalogoDocs()
  const documento = useDocumentosDocumento()
  const id_Relacion_Persona_Documento =
    useDocumentosId_Relacion_Persona_Documento()

  const notificacion = useDocumentosNotification()
  const uploadDoc = useDocumentosUploadDoc()

  // #endregion selectors

  // #region useRef
  // #endregion

  // #region Options
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Internal States
  const [stringBase64, setStringBase64ShowPassword] = useState("")
  const [showDropZone, setShowDropZone] = useState(false)
  const [showPdfViewer, setShowPdfViewer] = useState(false)
  const [showModalInsertDocumento, setModalInsertDocumento] = useState(false)
  const [documentList, setDocumentList] = useState([])
  const [iconClick, setIconClick] = useState("lupa")

  // #endregion

  // #region useEffects

  // useEffect(() => {
  //   //console.log("Montando Componente: Documentacion")
  //   if (altaAlumno) {
  //     const id_Nivel_Educativo = formik.values["id_Nivel_Educativo"]
  //       ? formik.values["id_Nivel_Educativo"]
  //       : -1
  //     if (id_Nivel_Educativo > 0) {
  //       //console.log("useEffect::id_Nivel_Educativo>0")
  //       //console.log("id_Nivel_Educativo:", id_Nivel_Educativo)
  //       dispatch(
  //         getDocumentosDocumentacion({
  //           nombreSolicitud: "documentacion",
  //           idNivelEducativo: formik.values["id_Nivel_Educativo"],
  //           idPersona: oPersona.id_Persona,
  //         })
  //       )
  //     } else {
  //       //console.log("id_Nivel_Educativo:", id_Nivel_Educativo)
  //     }
  //   }
  // }, [formik.values["id_Nivel_Educativo"]])

  useEffect(() => {
    if (notificacion.length > 0) {
      //console.log(notificacion)
      toast.success(notificacion, {
        autoClose: 2000,
      })
      dispatch(unsetDocumentosNotificacion())
    }
  }, [notificacion])

  useEffect(() => {
    if (uploadDoc && uploadDoc.size > 0) {
      //console.log(uploadDoc)
      const parts = uploadDoc.name.split("/") // Divide por '/'
      const filenameWithExtension = parts[parts.length - 1] // Toma el último elemento, que incluye ".pdf"

      const match = uploadDoc.name.match(/(\d+)\.[^\.]+$/)
      if (match) {
        setDocumentList(
          (documentList || [])?.map(doc => {
            return doc.id_Relacion_Persona_Documento == match[1]
              ? {
                  ...doc,
                  Notas: filenameWithExtension,
                }
              : doc
          })
        )
      }
    }
  }, [uploadDoc])

  useEffect(() => {
    if (altaAlumno) {
      return
    }
    //console.log("useEffect::getDocumentosDocumentacion")
    dispatch(
      getDocumentosDocumentacion({
        nombreSolicitud: "documentacion",
        idNivelEducativo: oAlumno.id_Nivel_Educativo,
        idPersona: oPersona.id_Persona,
      })
    )
  }, [oPersona])

  useEffect(() => {
    //console.log("documentos: ", documentos)
    setDocumentList(
      (documentos || [])?.map(doc => {
        return { ...doc, Descripcion: "" }
      })
    )
  }, [documentos])

  useEffect(() => {
    //console.log("docsCatalogo", docsCatalogo)
  }, [docsCatalogo])

  useEffect(() => {
    if (documento) {
      //console.log("documento", documento)
      setStringBase64ShowPassword(documento)
      if (iconClick === "lupa") {
        setShowPdfViewer(true)
      } else {
        descargarArchivo()
      }
    }
  }, [documento])

  useEffect(() => {
    if (refreshListaDocs) {
      dispatch(
        getDocumentosDocumentacion({
          nombreSolicitud: "documentacion",
          idNivelEducativo: 4,
          idPersona: oPersona.id_Persona,
        })
      )
      dispatch(unsetDocumentosRefreshListaDocs())
    }
  }, [refreshListaDocs])

  // #endregion

  // #region functions

  const toggleDropZoneVisibility = () => {
    setShowDropZone(!showDropZone)
  }

  const toggleModalInsertDoc = () => {
    setModalInsertDocumento(!showModalInsertDocumento)
  }

  const handleDropAccepted = ({ formData, base64Files, identificator }) => {
    //console.log("id: ", id)
    const updatedFormData = new FormData()
    let hasFile = false
    if (!id_Relacion_Persona_Documento || id_Relacion_Persona_Documento < 1) {
      //console.log(
      "id_Relacion_Persona_Documento: ", id_Relacion_Persona_Documento
      //)
      toast.error("No existe referencia válida.", {
        autoClose: 2000,
      })
      console.error("No existe referencia válida.")
    } else {
      for (let [key, value] of formData.entries()) {
        if (key === "file") {
          hasFile = true

          // Cambia el nombre del archivo
          const renamedFile = new File(
            [value],
            id_Relacion_Persona_Documento.toString() + ".pdf",
            {
              type: value.type,
              lastModified: value.lastModified,
            }
          )

          // Agrega el archivo renombrado al nuevo FormData
          updatedFormData.append("file", renamedFile)
        } else {
          // Copia otros datos al nuevo FormData si es necesario
          updatedFormData.append(key, file)
        }
      }

      if (hasFile) {
        dispatch(
          postDocumentosUploadFile(
            {
              nombreSolicitud: "uploadfile",
              idAlumno: idAlumno,
              idPersona: oPersona.id_Persona,
              id_Relacion_Persona_Documento: id_Relacion_Persona_Documento,
              idPersonaAuthenticated: idPersonaAuthenticated,
            },
            updatedFormData
          )
        )
        //dispatch(setDocumentosid_Relacion_Persona_Documento(0))
        toggleDropZoneVisibility()
      } else {
        toast.error("formData está vacío o no contiene el archivo esperado.", {
          autoClose: 2000,
        })
        console.error("formData está vacío o no contiene el archivo esperado.")
      }
    }
  }

  const handleEnviarButton = id => {
    // if (isAuthenticated && idPersonaAuthenticated > 0) {
    //   dispatch(
    //     onPostCajaEnvioRecibo({
    //       nombreSolicitud: "enviarorecibo",
    //       idPersona: idPersonaAuthenticated,
    //       idReciboPago: id,
    //     })
    //   )
    // }
  }

  const printInvoice = () => {
    window.print()
  }

  const onClickLinkUploadFile = id_Relacion_Persona_Documento => {
    //console.log("id_Relacion_Persona_Documento:", id_Relacion_Persona_Documento)
    dispatch(
      setDocumentosid_Relacion_Persona_Documento(id_Relacion_Persona_Documento)
    )
    toggleDropZoneVisibility()
  }

  const onClosePdfViewer = () => {
    setShowPdfViewer(false)
    dispatch(getDocumentosUnsetDocumento(null))
  }

  const updateListDocs = () => {
    dispatch(
      putDocumentosUpdateListaDocumentos({
        nombreSolicitud: "updatelistadocs",
        lista: documentList.map(doc => {
          return {
            id_Relacion_Persona_Documento: doc.id_Relacion_Persona_Documento,
            Original: doc.Original,
            Copias: doc.Copias,
          }
        }),
        idPersona: oPersona.id_Persona,
        idPersonaAuthenticated: idPersonaAuthenticated,
      })
    )
  }

  const handleButtonPlus = (id_Relacion_Persona_Documento, counter) => {
    setDocumentList(
      (documentList || [])?.map(doc => {
        return doc.id_Relacion_Persona_Documento ===
          id_Relacion_Persona_Documento
          ? {
              ...doc,
              Original: counter + 1,
            }
          : doc
      })
    )

    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      updateListDocs()
      //console.log("Counter UP!")
    }, 2000) // Espera 500 ms antes de despachar la acción
  }

  const handleButtonPlusAltaAlumno = id_Documento => {
    let documentosAcumulados = formik.values["docs"]
      ? [...formik.values["docs"]]
      : []

    documentosAcumulados = documentosAcumulados.map(doc =>
      doc.id_Documento === id_Documento
        ? { ...doc, Original: doc.Original + 1 }
        : doc
    )

    // Actualiza el campo 'docs' en Formik
    formik.setFieldValue("docs", documentosAcumulados)
  }

  const handleButtonMinus = (id_Relacion_Persona_Documento, counter) => {
    setDocumentList(
      (documentList || [])?.map(doc => {
        return doc.id_Relacion_Persona_Documento ===
          id_Relacion_Persona_Documento
          ? {
              ...doc,
              Original: counter - 1,
            }
          : doc
      })
    )

    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      updateListDocs()
      //console.log("Counter DOWN!")
    }, 2000) // Espera 500 ms antes de despachar la acción
  }

  const handleButtonMinusAltaAlumno = id_Documento => {
    let documentosAcumulados = formik.values["docs"]
      ? [...formik.values["docs"]]
      : []

    documentosAcumulados = documentosAcumulados.map(doc =>
      doc.id_Documento === id_Documento
        ? { ...doc, Original: doc.Original - 1 }
        : doc
    )

    // Actualiza el campo 'docs' en Formik
    formik.setFieldValue("docs", documentosAcumulados)
  }

  const handleButtonCopiasPlus = (id_Relacion_Persona_Documento, counter) => {
    setDocumentList(
      (documentList || [])?.map(doc => {
        return doc.id_Relacion_Persona_Documento ===
          id_Relacion_Persona_Documento
          ? {
              ...doc,
              Copias: counter + 1,
            }
          : doc
      })
    )

    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      updateListDocs()
      //console.log("Counter UP!")
    }, 2000) // Espera 500 ms antes de despachar la acción
  }

  const handleButtonCopiasPlusAltaAlumno = id_Documento => {
    let documentosAcumulados = formik.values["docs"]
      ? [...formik.values["docs"]]
      : []

    documentosAcumulados = documentosAcumulados.map(doc =>
      doc.id_Documento === id_Documento
        ? { ...doc, Copias: doc.Copias + 1 }
        : doc
    )

    // Actualiza el campo 'docs' en Formik
    formik.setFieldValue("docs", documentosAcumulados)
  }

  const handleButtonCopiasMinus = (id_Relacion_Persona_Documento, counter) => {
    setDocumentList(
      (documentList || [])?.map(doc => {
        return doc.id_Relacion_Persona_Documento ===
          id_Relacion_Persona_Documento
          ? {
              ...doc,
              Copias: counter - 1,
            }
          : doc
      })
    )

    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      updateListDocs()
      //console.log("Counter DOWN!")
    }, 2000) // Espera 500 ms antes de despachar la acción
  }

  const handleButtonCopiasMinusAltaAlumno = id_Documento => {
    let documentosAcumulados = formik.values["docs"]
      ? [...formik.values["docs"]]
      : []

    documentosAcumulados = documentosAcumulados.map(doc =>
      doc.id_Documento === id_Documento
        ? { ...doc, Copias: doc.Copias - 1 }
        : doc
    )

    // Actualiza el campo 'docs' en Formik
    formik.setFieldValue("docs", documentosAcumulados)
  }

  const handlerDelDocumento = (documento, event) => {
    //console.log("event", event)
    //console.log("documento", documento)
    if (!documento) {
      //console.log("No hay documento", documento)
      toast.error("No existe documento que borrar.", {
        autoClose: 2000,
      })
    } else {
      if (!altaAlumno) {
        dispatch(
          delDocumentosDelDocumento({
            nombreSolicitud: "deldoctopersona",
            idPersona: oPersona.id_Persona,
            id_Relacion_Persona_Documento:
              documento.id_Relacion_Persona_Documento,
            idPersonaAuthenticated: idPersonaAuthenticated,
          })
        )
      } else {
        // Lo deaparezco de los documntos acumulados.
        //console.log("Verifica si docs existe y es un arreglo")
        let documentosAcumulados = formik.values["docs"]
          ? [...formik.values["docs"]]
          : []
        //console.log("documentosAcumulados: ", documentosAcumulados)

        // Agrega el nuevo documento
        //console.log("expulsa al documento en cuestión")
        documentosAcumulados = documentosAcumulados.filter(
          doc => doc.id_Documento !== documento.id_Documento
        )

        //console.log("documentosAcumulados: ", documentosAcumulados)

        // Actualiza el campo 'docs' en Formik
        formik.setFieldValue("docs", documentosAcumulados)
        documentosAcumulados = formik.values["docs"]
          ? [...formik.values["docs"]]
          : []
        //console.log("documentosAcumulados: ", documentosAcumulados)
      }
    }
  }

  const downloadFile = nameFile => {
    dispatch(
      getDocumentosDocumento({
        nombreSolicitud: "getdoc",
        fileName: nameFile,
        idPersona: oPersona.id_Persona,
        type: "documento",
      })
    )
  }

  const deleteFile = id_Relacion_Persona_Documento => {
    dispatch(
      delDocumentosDelDocumento({
        nombreSolicitud: "deldoctopersona",
        id_Relacion_Persona_Documento: id_Relacion_Persona_Documento,
        idPersona: oPersona.id_Persona,
        idPersonaAuthenticated: idPersonaAuthenticated,
      })
    )
  }

  const descargarArchivo = () => {
    // Convertir base64 a un formato Blob
    const linkSource = `data:application/pdf;base64,${stringBase64}`
    const downloadLink = document.createElement("a")
    const fileName = "documento.pdf"

    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click() // Simula un clic para descargar el archivo
  }

  const handleClickIcon = (nameFile, icono) => {
    setIconClick(icono)
    downloadFile(nameFile)
  }

  // #endregion

  //#region Formik form

  const { id_Persona = -1, docs = [] } = oPersona

  // #endregion

  //console.log("altaAlumno: ", altaAlumno)

  return (
    <React.Fragment>
      {/* PDFViewer */}
      <Modal
        size="lg"
        isOpen={showPdfViewer}
        onClosed={onClosePdfViewer}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Visor PDF
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClosePdfViewer}
            aria-label="Close"
          ></button>
        </div>
        <ModalBody className="m-0 mb-0 mt-0">
          <PDFViewer base64String={stringBase64} />
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary"
            data-bs-target="#firstmodal"
            onClick={onClosePdfViewer}
          >
            Cerrar
          </button>
        </ModalFooter>
      </Modal>

      {/* DocumentosListado */}
      <Modal isOpen={showModalInsertDocumento}>
        <ModalBody>
          <DocumentosListado
            documentos={docsxEntregar}
            oPersona={oPersona}
            formik={formik}
            closeFn={toggleModalInsertDoc}
          />
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary"
            data-bs-target="#firstmodal"
            onClick={toggleModalInsertDoc}
          >
            Cerrar
          </button>
        </ModalFooter>
      </Modal>

      <DropzoneComponent
        onDropAccepted={handleDropAccepted}
        isOpen={showDropZone}
        maxFiles={1}
        id={id_Relacion_Persona_Documento}
      />

      {/* Header - Botón Agregar Documento */}
      <Row className="mb-2">
        <Col className="d-flex justify-content-end">
          <div className="text-sm-end">
            <Button
              color="primary"
              type="button"
              className="btn btn-primary mb-2 me-2"
              onClick={() => {
                toggleModalInsertDoc()
              }}
            >
              <i className="mdi mdi-plus me-1"></i> Agregar Documento
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          {isLoading ? (
            <Spinners setLoading={() => {}} />
          ) : (
            <div className="table-responsive">
              <Table className="table table-condensed align-middle mb-0 table-nowrap">
                <thead className="table-light">
                  <tr>
                    <th>Documento</th>
                    <th>Originales</th>
                    <th>Copias</th>
                    <th className="ms-4 ">
                      <i
                        id={`viewtooltipicono`}
                        className="mdi mdi-database-outline font-size-18"
                      />
                    </th>
                    <UncontrolledTooltip
                      placement="top"
                      target={`viewtooltipicono`}
                    >
                      Archivos
                    </UncontrolledTooltip>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {altaAlumno ? (
                    <>
                      {formik.values["docs"].map(document => (
                        <tr
                          key={
                            document.id_Relacion_Persona_Documento === -1
                              ? document.id_Documento
                              : document.id_Relacion_Persona_Documento
                          }
                        >
                          {/* Nombre Documento, Originales, Copia */}
                          <td>{document.Nombre_Documento}</td>
                          {/* Originales */}
                          <td>
                            <div>
                              {/* -, #, + */}
                              <InputGroup>
                                {/* - */}
                                <div className="input-group-append me-2">
                                  <Button
                                    to="#"
                                    disabled={!(document.Original > 0)}
                                    onClick={() => {
                                      if (!altaAlumno) {
                                        handleButtonMinus(
                                          document.id_Relacion_Persona_Documento,
                                          document.Original
                                        )
                                      } else {
                                        handleButtonMinusAltaAlumno(
                                          document.id_Documento
                                        )
                                      }
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip!!-${document.id_Documento}`}
                                  >
                                    <i className="mdi mdi-minus" />
                                  </Button>
                                </div>

                                {/* # */}
                                <Label className="mt-1">
                                  <h5>{document.Original}</h5>
                                </Label>

                                <div className="input-group-prepend ms-2">
                                  {/* + */}
                                  <Button
                                    to="#"
                                    disabled={
                                      !(
                                        document.Original >= 0 &&
                                        document.Original < 10
                                      )
                                    }
                                    onClick={() => {
                                      if (!altaAlumno) {
                                        handleButtonPlus(
                                          document.id_Relacion_Persona_Documento,
                                          document.Original
                                        )
                                      } else {
                                        handleButtonPlusAltaAlumno(
                                          document.id_Documento
                                        )
                                      }
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip!-${document.id_Documento}`}
                                  >
                                    <i className="mdi mdi-plus" />
                                  </Button>
                                </div>
                              </InputGroup>
                            </div>
                          </td>
                          {/* Copias */}
                          <td>
                            <div>
                              <InputGroup>
                                <div className="input-group-append me-2">
                                  <Button
                                    to="#"
                                    disabled={!(document.Copias > 0)}
                                    onClick={() => {
                                      if (!altaAlumno) {
                                        handleButtonCopiasMinus(
                                          document.id_Relacion_Persona_Documento,
                                          document.Original
                                        )
                                      } else {
                                        handleButtonCopiasMinusAltaAlumno(
                                          document.id_Documento
                                        )
                                      }
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip&#!-${document.id_Documento}`}
                                  >
                                    <i className="mdi mdi-minus" />
                                  </Button>
                                </div>

                                <Label className="mt-1">
                                  <h5>{document.Copias}</h5>
                                </Label>
                                <div className="input-group-prepend ms-2">
                                  <Button
                                    to="#"
                                    disabled={
                                      !(
                                        document.Copias >= 0 &&
                                        document.Copias < 10
                                      )
                                    }
                                    onClick={() => {
                                      if (!altaAlumno) {
                                        handleButtonCopiasPlus(
                                          document.id_Relacion_Persona_Documento,
                                          document.Original
                                        )
                                      } else {
                                        handleButtonCopiasPlusAltaAlumno(
                                          document.id_Documento
                                        )
                                      }
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip&-${document.id_Documento}`}
                                  >
                                    <i className="mdi mdi-plus" />
                                  </Button>
                                </div>
                              </InputGroup>
                            </div>
                          </td>
                          {/* Notas */}
                          <td>
                            {document?.Notas?.length > 0 ? (
                              <>
                                <Link
                                  to="#"
                                  id={`viewtooltipicono-${document?.id_Relacion_Persona_Documento}`}
                                  onClick={event => {
                                    handleClickIcon(document.Notas, "lupa")
                                  }}
                                  className="action-icon text-secondary me-3"
                                >
                                  <i className="mdi mdi-magnify font-size-18" />
                                </Link>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`viewtooltipicono-${document?.id_Relacion_Persona_Documento}`}
                                >
                                  Ver
                                </UncontrolledTooltip>

                                <Link
                                  to="#"
                                  id={`viewtooltipiconodownload-${document?.id_Relacion_Persona_Documento}`}
                                  onClick={event => {
                                    handleClickIcon(document.Notas, "descargar")
                                  }}
                                  className="action-icon text-secondary me-3"
                                >
                                  <i className="mdi mdi-download font-size-18" />
                                </Link>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`viewtooltipiconodownload-${document?.id_Relacion_Persona_Documento}`}
                                >
                                  Descargar
                                </UncontrolledTooltip>

                                <Link
                                  to="#"
                                  id={`viewtooltipiconodelete-${document?.id_Relacion_Persona_Documento}`}
                                  onClick={() => {
                                    deleteFile(
                                      document.id_Relacion_Persona_Documento
                                    )
                                  }}
                                  className="action-icon text-danger me-3"
                                >
                                  <i className="mdi mdi-file-remove-outline font-size-18" />
                                </Link>

                                <UncontrolledTooltip
                                  placement="top"
                                  target={`viewtooltipiconodelete-${document?.id_Relacion_Persona_Documento}`}
                                >
                                  Borrar Archivo
                                </UncontrolledTooltip>
                              </>
                            ) : null}
                          </td>
                          {/* Upload, Delete */}
                          <td>
                            {/* Upload */}
                            {/* <Link
                              to="#"
                              id={`viewtooltipiconoUpload-${document?.id_Relacion_Persona_Documento}`}
                              onClick={() => {
                                onClickLinkUploadFile(
                                  document.id_Relacion_Persona_Documento
                                )
                              }}
                              className="action-icon text-primary me-3"
                            >
                              <i className="mdi mdi-upload font-size-18" />
                            </Link>
                            <UncontrolledTooltip
                              placement="top"
                              target={`viewtooltipiconoUpload-${document?.id_Relacion_Persona_Documento}`}
                            >
                              Subir Archivo
                            </UncontrolledTooltip> */}
                            {/* Delete */}
                            <Link
                              to="#"
                              id={`viewtooltipiconoRemove-${document?.id_Documento}`}
                              onClick={event =>
                                handlerDelDocumento(document, event)
                              }
                              className="action-icon text-danger ms-3"
                            >
                              <i className="mdi mdi-trash-can font-size-18" />
                            </Link>
                            <UncontrolledTooltip
                              placement="top"
                              target={`viewtooltipiconoRemove-${document?.id_Documento}`}
                            >
                              Borrar Registro
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      ))}
                    </>
                  ) : (
                    <>
                      {documentList.map(document => (
                        <tr key={document.id_Relacion_Persona_Documento}>
                          {/* Nombre Documento, Originales, Copia */}
                          <td>{document.Nombre_Documento}</td>
                          {/* Originales */}
                          <td>
                            <div>
                              {/* -, #, + */}
                              <InputGroup>
                                {/* - */}
                                <div className="input-group-append me-2">
                                  <Button
                                    to="#"
                                    disabled={!(document.Original > 0)}
                                    onClick={() => {
                                      handleButtonMinus(
                                        document.id_Relacion_Persona_Documento,
                                        document.Original
                                      )
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip!!-${document.id_Relacion_Persona_Documento}`}
                                  >
                                    <i className="mdi mdi-minus" />
                                  </Button>
                                </div>

                                {/* # */}
                                <Label className="mt-1">
                                  <h5>{document.Original}</h5>
                                </Label>

                                <div className="input-group-prepend ms-2">
                                  {/* + */}
                                  <Button
                                    to="#"
                                    disabled={
                                      !(
                                        document.Original >= 0 &&
                                        document.Original < 10
                                      )
                                    }
                                    onClick={() => {
                                      handleButtonPlus(
                                        document.id_Relacion_Persona_Documento,
                                        document.Original
                                      )
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip!-${document.id_Relacion_Persona_Documento}`}
                                  >
                                    <i className="mdi mdi-plus" />
                                  </Button>
                                </div>
                              </InputGroup>
                            </div>
                          </td>
                          {/* Copias */}
                          <td>
                            <div>
                              <InputGroup>
                                <div className="input-group-append me-2">
                                  <Button
                                    to="#"
                                    disabled={!(document.Copias > 0)}
                                    onClick={() => {
                                      handleButtonCopiasMinus(
                                        document.id_Relacion_Persona_Documento,
                                        document.Copias
                                      )
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip&#!-${document.id_Relacion_Persona_Documento}`}
                                  >
                                    <i className="mdi mdi-minus" />
                                  </Button>
                                </div>

                                <Label className="mt-1">
                                  <h5>{document.Copias}</h5>
                                </Label>
                                <div className="input-group-prepend ms-2">
                                  <Button
                                    to="#"
                                    disabled={
                                      !(
                                        document.Copias >= 0 &&
                                        document.Copias < 10
                                      )
                                    }
                                    onClick={() => {
                                      handleButtonCopiasPlus(
                                        document.id_Relacion_Persona_Documento,
                                        document.Copias
                                      )
                                    }}
                                    className="btn btn-sm btn-soft-primary mt-0"
                                    id={`viewtooltip&-${document.id_Relacion_Persona_Documento}`}
                                  >
                                    <i className="mdi mdi-plus" />
                                  </Button>
                                </div>
                              </InputGroup>
                            </div>
                          </td>
                          {/* Notas */}
                          <td>
                            {document?.Notas?.length > 0 ? (
                              <>
                                <Link
                                  to="#"
                                  id={`viewtooltipicono-${document?.id_Relacion_Persona_Documento}`}
                                  onClick={event => {
                                    handleClickIcon(document.Notas, "lupa")
                                  }}
                                  className="action-icon text-secondary me-3"
                                >
                                  <i className="mdi mdi-magnify font-size-18" />
                                </Link>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`viewtooltipicono-${document?.id_Relacion_Persona_Documento}`}
                                >
                                  Ver
                                </UncontrolledTooltip>

                                <Link
                                  to="#"
                                  id={`viewtooltipiconodownload-${document?.id_Relacion_Persona_Documento}`}
                                  onClick={event => {
                                    handleClickIcon(document.Notas, "descargar")
                                  }}
                                  className="action-icon text-secondary me-3"
                                >
                                  <i className="mdi mdi-download font-size-18" />
                                </Link>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`viewtooltipiconodownload-${document?.id_Relacion_Persona_Documento}`}
                                >
                                  Descargar
                                </UncontrolledTooltip>

                                <Link
                                  to="#"
                                  id={`viewtooltipiconodelete-${document?.id_Relacion_Persona_Documento}`}
                                  onClick={() => {
                                    deleteFile(
                                      document.id_Relacion_Persona_Documento
                                    )
                                  }}
                                  className="action-icon text-danger me-3"
                                >
                                  <i className="mdi mdi-file-remove-outline font-size-18" />
                                </Link>

                                <UncontrolledTooltip
                                  placement="top"
                                  target={`viewtooltipiconodelete-${document?.id_Relacion_Persona_Documento}`}
                                >
                                  Borrar Archivo
                                </UncontrolledTooltip>
                              </>
                            ) : null}
                          </td>
                          {/* Upload, Delete */}
                          <td>
                            {/* Upload */}
                            <Link
                              to="#"
                              id={`viewtooltipiconoUpload-${document?.id_Relacion_Persona_Documento}`}
                              onClick={() => {
                                onClickLinkUploadFile(
                                  document.id_Relacion_Persona_Documento
                                )
                              }}
                              className="action-icon text-primary me-3"
                            >
                              <i className="mdi mdi-upload font-size-18" />
                            </Link>
                            <UncontrolledTooltip
                              placement="top"
                              target={`viewtooltipiconoUpload-${document?.id_Relacion_Persona_Documento}`}
                            >
                              Subir Archivo
                            </UncontrolledTooltip>
                            {/* Delete */}
                            <Link
                              to="#"
                              id={`viewtooltipiconoRemove-${document?.id_Relacion_Persona_Documento}`}
                              onClick={event =>
                                handlerDelDocumento(document, event)
                              }
                              className="action-icon text-danger ms-3"
                            >
                              <i className="mdi mdi-trash-can font-size-18" />
                            </Link>
                            <UncontrolledTooltip
                              placement="top"
                              target={`viewtooltipiconoRemove-${document?.id_Relacion_Persona_Documento}`}
                            >
                              Borrar Registro
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>

      <Row className="mt-4">
        {!altaAlumno ? (
          <>
            <Col sm="6">
              {/* <Link to="/ecommerce-products" className="btn btn-secondary">
            <i className="mdi mdi-arrow-left me-1" /> Continue Shopping
          </Link> */}
            </Col>
            <Col sm="6">
              <div className="d-print-none">
                <div className="float-end">
                  <div className="d-flex flex-wrap gap-2">
                    <Link
                      to="#"
                      onClick={printInvoice}
                      className="btn btn-success  me-2"
                    >
                      <i className="fa fa-print" />
                    </Link>

                    <Button
                      type="button"
                      color="primary"
                      onClick={() => {
                        handleEnviarButton(idReciboEnviar)
                      }}
                    >
                      <i className="bx bx-mail-send font-size-16 align-middle me-2"></i>{" "}
                      Enviar
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </>
        ) : (
          <></>
        )}
      </Row>
    </React.Fragment>
  )
}

export default Documentacion
